<template>
  <validation-observer v-slot="{ valid }" id="tipologia-anel-simulacao">
    <validation-helper
      :interceptor="valid"
      @isValid="$emit('stepReleased', $event)"
    />
    <v-row
      class="mx-auto row-percent"
      v-for="(percentual, i) in Object.entries(percentuais)"
      :key="i"
    >
      <v-col class="px-0 pt-8 cols-title" cols="1">
        <v-label>{{ percentual[0] }}</v-label>
      </v-col>
      <v-col class="pb-0 px-0 cols-type" cols="5">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-select
            no-gutters
            outlined
            :value="percentual[1].tipoTipologia"
            :items="['Informar percentual', 'Saneamento do VOC']"
            :error-messages="errors"
            @input="setPercentuais(percentual[0], 'tipoTipologia', $event)"
            @change="clearInputs(i, percentual[0])"
          />
        </validation-provider>
      </v-col>
      <template v-if="percentual[1].tipoTipologia == 'Informar percentual'">
        <v-col class="pb-0 cols-percentage" cols="6">
          <validation-provider v-slot="{ errors }" rules="between:0,100">
            <v-text-field
              :value="percentual[1].perc_fator_saneamento"
              label="Percentual de Saneamento (%)"
              suffix="%"
              type="number"
              min="0"
              max="100"
              :error-messages="errors"
              @input="
                setPercentuais(percentual[0], 'perc_fator_saneamento', $event)
              "
            />
          </validation-provider>
        </v-col>
      </template>
      <template v-else>
        <v-col class="pb-0 pr-0 cols-percentage" md="6">
          <v-tooltip
            bottom
            :disabled="calculosSaneamentosVoc[i].nome_calculo ? false : true"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  :value="calculosSaneamentosVoc[i].nome_calculo"
                  label="Saneamento do VOC"
                  placeholder="Selecione um cálculo"
                  outlined
                  readonly
                  :error-messages="errors"
                  @focus="dialogsSelectors[i] = true"
                />
              </validation-provider>
            </template>
            <span>{{ calculosSaneamentosVoc[i].nome_calculo }}</span>
          </v-tooltip>
          <dialog-seletor-saneamento-voc
            :activated.sync="dialogsSelectors[i]"
            @selected="setSaneamentoVoc(i, $event)"
          />
        </v-col>
      </template>
    </v-row>
  </validation-observer>
</template>

<script>
export default {
  components: {
    ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
    DatePicker: () => import("@/components/general/DatePicker.vue"),
    SwitchUploadCsv: () =>
      import("@/components/simulacoesLaudosIncrementais/SwitchUploadCsv.vue"),
    DialogSeletorSaneamentoVoc: () =>
      import("@/components/general/selectors/GeneralCalculosComCaSelector.vue"),
  },

  data: () => ({
    dialogSelector: false,
    dialogsSelectors: {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
      8: false,
      9: false,
    },
  }),

  computed: {
    percentuais: {
      get() {
        return this.$store.state.simulacaoLaudoIncremental.percentuais;
      },
    },
    calculosSaneamentosVoc: {
      get() {
        return this.$store.state.simulacaoLaudoIncremental.saneamentoVoc
          .calculos;
      },
    },
  },

  methods: {
    setPercentuais(tipologia, key, value) {
      this.$store.dispatch("setSimulacaoLaudoIncremental", {
        percentuais: { [tipologia]: { [key]: value } },
      });
    },

    setCalculos(key, value) {
      this.$store.dispatch("setSimulacaoLaudoIncremental", {
        saneamentoVoc: { calculos: { [key]: value } },
      });
    },

    setSaneamentoVoc(key, values) {
      this.setCalculos(key, {
        nome_calculo: `#${values.id} - ${values.nome}`,
        saneamento_voc_id: values.id,
      });
      this.dialogsSelectors[key] = false;
    },

    clearInputs(i, tipologia) {
      this.setCalculos(i, { nome_calculo: null, saneamento_voc_id: null });
      this.setPercentuais(tipologia, "perc_fator_saneamento", "100");
    },
  },
};
</script>
